import { render, staticRenderFns } from "./TabInsureContract.vue?vue&type=template&id=119e3450&scoped=true"
import script from "./TabInsureContract.vue?vue&type=script&lang=ts"
export * from "./TabInsureContract.vue?vue&type=script&lang=ts"
import style0 from "./TabInsureContract.vue?vue&type=style&index=0&id=119e3450&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "119e3450",
  null
  
)

export default component.exports